// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"JEdFO4IlYP0fZXkQ","iconPlaceholder":"PEdGMwWdx10lGYFJ","textContent":"AOqjjzmrR8obIOjZ"};